import React from 'react';
import { I18n } from 'src/translations/i18n';
import { CircularProgress, makeStyles } from '@material-ui/core';

import './index.less';

const useStyles = makeStyles(({ palette }) => ({
  text: {
    color: palette.text.color
  }
}));

function Loading() {
  const classes = useStyles();

  return (
    <div className="suspense-loader">
      <span className="circle">
        <CircularProgress size={40} />
      </span>
      <p className={`loading ${classes.text}`}>
        {I18n.t('Loading')}
        <span className="dot-1 dot">.</span>
        <span className="dot-2 dot">.</span>
        <span className="dot-3 dot">.</span>
      </p>
    </div>
  );
}

export default Loading;
